import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/index.css';
import { useAuthStore } from '../stores';
import { Alert } from '../../commons/components';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { signin } from '../../redux/actions/actAuth';

const initialState = {
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
  errorMessage: '',
  successMessage: '',
};

export function FormRegister() {
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  const [formData, setFormData] = useState(initialState);

  // const [authState, authActions] = useAuthStore();

  const dispatch = useDispatch();

  const history = useHistory();

  const handleSubmit = async (event) => {
    event.preventDefault();

    // await authActions.login({ email, password });
    try {
      console.log('ini data yang telah diisi', formData);
      dispatch(signin(formData, history));
    } catch (error) {
      error.response.data.msg &&
        setFormData({
          ...formData,
          successMessage: '',
          errorMessage: error.response.data.msg,
        });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value }); //dengan ini hanya field yang diisi yang akan di update
  };

  let errorUi;

  // if (authState.error) {
  //   errorUi = (
  //     <div className='space-y-1'>
  //       <Alert type='error' content={authState.error} />
  //     </div>
  //   );
  // }

  return (
    <div className='mt-8'>
      <div className='mt-6'>
        <form onSubmit={handleSubmit} className='space-y-6'>
          <div>
            <label
              htmlFor='name'
              className='block text-sm font-medium text-gray-700'
            >
              Full Name
            </label>
            <div className='mt-1'>
              <input
                id='name'
                name='name'
                type='name'
                autoComplete='name'
                required
                className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                placeholder='your fullname'
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700'
            >
              Email address
            </label>
            <div className='mt-1'>
              <input
                id='email'
                name='email'
                type='email'
                autoComplete='email'
                required
                className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                placeholder='example@example.com'
                onChange={handleChange}
              />
            </div>
          </div>

          <div className='space-y-1'>
            <label
              htmlFor='password'
              className='block text-sm font-medium text-gray-700'
            >
              Password
            </label>
            <div className='mt-1'>
              <input
                id='password'
                name='password'
                type='password'
                autoComplete='current-password'
                required
                className='appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                onChange={handleChange}
                placeholder='****************'
              />
            </div>
          </div>
          {errorUi}

          <div className='flex items-center justify-between'>
            <div className='text-sm'>
              Do you have an Account?
              <Link to='/auth' className='text-sm ml-1'>
                Login
              </Link>
            </div>
            <button
              type='submit'
              className='btn btn_primary ml-auto uppercase'
              data-dashlane-rid='fd66152da8a85f08'
              data-dashlane-label='true'
              data-form-type='action,login'
            >
              Register
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
